import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

const initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getPoints = createAsyncThunk(
  "points/getPoints",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 10, ...rest } = args || {};
      const params = new URLSearchParams({ page, size });

      Object.entries(rest).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.append(key, value);
        }
      });

      const { data } = await axiosInstance.get(`/points?${params.toString()}`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

export const givePoints = createAsyncThunk(
  "points/givePoints",
  async (args, thunkApi) => {
    try {
      // args: { user, points }
      const { data } = await axiosInstance.post(`/points`, args);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

const newPointsSlice = createSlice({
  name: "newPoints",
  initialState,
  extraReducers: (b) => {
    b.addCase(getPoints.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(getPoints.fulfilled, (s, { payload }) => {
        s.isLoading = false;
        s.data = payload.data?.data || [];
        s.itemsCount = payload.data?.itemsCount || 0;
        s.pages = payload.data?.pages || 0;
      })
      .addCase(getPoints.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      })

      .addCase(givePoints.pending, (s) => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(givePoints.fulfilled, (s) => {
        s.isLoading = false;
      })
      .addCase(givePoints.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      });
  },
});

export default newPointsSlice.reducer;
